export const DEFAULT_THEME = (import.meta.env.VITE_DEFAULT_THEME as string) || 'synthesis'
export const DEFAULT_THEME_MODE = (import.meta.env.VITE_DEFAULT_THEME_MODE as 'system' | 'light' | 'dark') || 'system'
export const DEFAULT_LOCALE = (import.meta.env.VITE_DEFAULT_LOCALE as 'ru' | 'en') || 'ru'
